module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAAXNSR0IB2cksfwAAADxQTFRFAAAA////////////////////////////////////////////////////////////////////////////2EloEwAAABR0Uk5TAKD/nxBvUCDPj79/cJCAwODfT9DgVjOAAAAAk0lEQVR4nH2R2xKDIAxEwxoTa6mA/v+/VgI4aov7ljOwmwtRkwMG+hV2XQCPQqQZK5GMXOkEvGaY5jcwFe5xkzcsdyzF5XOlS40MuYiiKtH8C7UeouVwrP3kKU5+NWegasinn3muDv5r4tqLVCJTi2wNplV1NRroaZzO8J1V8bZ/DIWEBdjawv35DJ6fj3ac2B3FF29sBKpWPiwWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/side-menu--icon--settings-selected.png
// module id = 941
// module chunks = 0